import type { ConnectedPosition, Overlay } from '@angular/cdk/overlay';
import type { ElementRef } from '@angular/core';

import type { Offset, WalkthroughType } from '../types';

export function flexiblePositionStrategyFactory(
  overlay: Overlay,
  origin: ElementRef,
  positions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
  ],
  offset: Offset = { offsetX: 16, offsetY: 16 },
) {
  return overlay
    .position()
    .flexibleConnectedTo(origin)
    .withPositions(positions)
    .withDefaultOffsetX(offset.offsetX)
    .withDefaultOffsetY(offset.offsetY)
    .withPush(true);
}

export function globalPositionStrategyFactory(overlay: Overlay) {
  return overlay.position().global().centerHorizontally().centerVertically();
}
export const resolveComponentScope = (walkthroughType?: WalkthroughType) =>
  walkthroughType ? 'walkthrough' : 'default';
